const BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api";

export async function apiFetch(url, options = {}) {
  const token = localStorage.getItem("token");

  // merge provided headers with auth
  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  // only set JSON content-type when sending a body
  const isFormData = options.body instanceof FormData;

  if (!isFormData && options.body && !headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }

  // fire request
  const res = await fetch(`${BASE_URL}${url}`, {
    ...options,
    headers,
  });

  // handle "no content" cases safely (204, etc.)
  if (res.status === 204) return null;

  // detect and parse response content type
  const contentType = res.headers.get("content-type") || "";
  let data;
  if (contentType.includes("application/json")) {
    data = await res.json();
  } else {
    data = await res.text();
  }

  // throw descriptive errors on failure
  if (!res.ok) {
    const message =
      (data && data.error) ||
      (typeof data === "string" && data) ||
      `HTTP ${res.status}`;
    const err = new Error(message);
    err.status = res.status;
    throw err;
  }

  return data;
}
